import React from 'react';

/**
 * CpscTabBar — CHA-230. Map-driven tab strip, extracted to kill the ~150 lines of copy-pasted
 * `<button className="flex-1 px-6 py-3 …">` blocks in ImportsPage. One config array of
 * `{ id, label, icon, color }` renders the whole bar; reused for the top-level Imports strip, the
 * nested CPSC sub-strip, and the CPSC Settings third-level strip.
 *
 * Colors map to LITERAL Tailwind class strings (never interpolated) so the JIT purge keeps them —
 * this reproduces the prior per-tab markup byte-for-byte.
 */
const ACTIVE = {
  green: 'text-green-600 border-b-2 border-green-600 bg-green-50/50',
  blue: 'text-blue-600 border-b-2 border-blue-600 bg-blue-50/50',
  cyan: 'text-cyan-600 border-b-2 border-cyan-600 bg-cyan-50/50',
  violet: 'text-violet-600 border-b-2 border-violet-600 bg-violet-50/50',
  emerald: 'text-emerald-600 border-b-2 border-emerald-600 bg-emerald-50/50',
  amber: 'text-amber-600 border-b-2 border-amber-600 bg-amber-50/50',
  orange: 'text-orange-600 border-b-2 border-orange-600 bg-orange-50/50',
};
const IDLE = 'text-slate-500 hover:text-slate-700 hover:bg-slate-50';

export default function CpscTabBar({ tabs = [], activeId, onSelect, className = '' }) {
  return (
    <div className={`flex border-b border-slate-200 ${className}`.trim()}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            onClick={() => onSelect(tab.id)}
            className={`flex-1 px-6 py-3 text-sm font-medium transition-colors ${active ? (ACTIVE[tab.color] || ACTIVE.orange) : IDLE}`}
          >
            <div className="flex items-center justify-center gap-2">
              {Icon && <Icon className="h-4 w-4" />}
              {tab.label}
            </div>
          </button>
        );
      })}
    </div>
  );
}
